export default __webpack_public_path__ + "static/media/distri.4073beac.png";